import { map, switchMap } from 'rxjs/operators';
import { TenantService } from './../../shared/services/tenant.service';
import { Component, inject, OnInit } from '@angular/core';
import { Fetchable } from '../../core/declarations/fetchable.interface';
import { Tenant } from '../../core/declarations/tenant.interface';
import { BehaviorSubject, Observable } from 'rxjs';
import { SelectOption } from '../../shared/components/forms/select/select.component';
import {
  ModalAbstractComponent,
  SelectModalBaseComponent
} from '@bling-fe/shared/modals/base-modal';
import { IonicModule } from '@ionic/angular';
import { TranslateModule } from '@ngx-translate/core';
import { AsyncPipe, NgFor, NgIf } from '@angular/common';
import { LogoComponent } from '../../shared/components/logo/logo.component';
import { UiErrorBoxComponent } from '@bling-fe/shared/ui-components/ui-error-box';
import { UiSkeletonComponent } from '@bling-fe/shared/ui-components/ui-skeleton';

@Component({
  selector: 'fl-select-tenant-modal',
  templateUrl: './select-tenant-modal.component.html',
  styleUrls: ['./select-tenant-modal.component.scss'],
  imports: [
    SelectModalBaseComponent,
    IonicModule,
    TranslateModule,
    NgFor,
    NgIf,
    AsyncPipe,
    UiSkeletonComponent,
    UiErrorBoxComponent,
    LogoComponent
  ]
})
export class SelectTenantModalComponent
  extends ModalAbstractComponent<{ value: Tenant }, SelectOption<Tenant>>
  implements OnInit
{
  tenants$: Observable<Fetchable<Tenant[]>>;
  public searchFilter = new BehaviorSubject<string>('');
  private tenantService = inject(TenantService);

  ngOnInit(): void {
    this.tenants$ = this.tenantService.data$.pipe(
      switchMap(tenants =>
        this.searchFilter.pipe(
          map(search => ({
            ...tenants,
            data: tenants.data.filter(t =>
              t.name.toLowerCase().includes(search.toLowerCase())
            )
          }))
        )
      )
    );
    this.fetchTenants();
  }

  fetchTenants() {
    this.tenantService.fetch();
  }
}
